import React, {ReactElement, PropsWithChildren} from "react";
import {useStore} from "@ui/stores";
import {observer} from "mobx-react-lite";

const DeviceTypeProvider = ({children}: PropsWithChildren<{}>): ReactElement => {
  const {settings} = useStore();
	const deviceTypeClassNamePrefix = "device-type"; // $device-type-class-name-prefix - значение переменной из css

  return (
    <div className={`${deviceTypeClassNamePrefix}-${settings.deviceType}`}>
      {children}
    </div>
  );
};

export default observer(DeviceTypeProvider);
